import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Layout } from "@/components/Layout";
import Index from "./pages/Index";
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import CaseStudies from "./pages/CaseStudies";
import Websites from "./pages/services/Websites";
import GbpSeo from "./pages/services/GbpSeo";
import Reputation from "./pages/services/Reputation";
import LeadGeneration from "./pages/services/LeadGeneration";
import Automation from "./pages/services/Automation";
import Reactivation from "./pages/services/Reactivation";
import FreeGbpAudit from "./pages/FreeGbpAudit";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/websites" element={<Websites />} />
              <Route path="/services/gbp-seo" element={<GbpSeo />} />
              <Route path="/services/reputation" element={<Reputation />} />
              <Route path="/services/lead-generation" element={<LeadGeneration />} />
              <Route path="/services/automation" element={<Automation />} />
              <Route path="/services/reactivation" element={<Reactivation />} />
              <Route path="/case-studies" element={<CaseStudies />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/free-gbp-audit" element={<FreeGbpAudit />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
